import React, { useEffect, useState } from 'react'
import logoSC from "../Imagenes/logoSCTKD.webp"
import compBg from "../Imagenes/comp-bg.webp"
import { Typography, Button, Paper, Modal } from '@material-ui/core';
import { useNavigate } from "react-router"
import { makeStyles } from '@material-ui/styles';
import { useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import moment from 'moment/moment';


const Styles = makeStyles({
    root: {
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#0a0d14",
        boxSizing: "border-box",
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    },
    bg: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url(${compBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        opacity: 0.25,
        zIndex: 0
    },
    content: {
        position: "relative",
        zIndex: 1,
        width: "100%",
        maxWidth: 360,
        margin: "0 auto",
        padding: "20px 16px 60px 16px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    header: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "16px",
        marginBottom: 16,
        backgroundColor: "rgba(20, 24, 33, 0.65)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: 16,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        boxSizing: "border-box"
    },
    logologo: {
        width: 70,
        height: "auto",
        objectFit: "contain",
        cursor: "pointer",
        transition: "transform 0.2s ease",
        "&:active": {
            transform: "scale(0.95)"
        }
    },
    titulo: {
        color: "#ffffff",
        fontWeight: 800,
        fontStyle: "italic",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: 22,
        textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)",
        "@media (max-width: 600px)": {
            fontSize: 18
        }
    },
    backBtn: {
        width: "100%",
        padding: "14px 24px",
        borderRadius: 12,
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: 15,
        color: "#ffffff",
        letterSpacing: 1,
        background: "linear-gradient(180deg, #990000 0%, #660000 100%)",
        border: "1px solid rgba(255, 0, 0, 0.3)",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
        cursor: "pointer",
        transition: "transform 0.2s ease, filter 0.2s ease",
        outline: "none",
        marginBottom: 24,
        "&:active": {
            transform: "scale(0.98)",
            filter: "brightness(1.2)"
        }
    },
    diaCard: {
        width: "100%",
        maxWidth: 360,
        minHeight: 420,
        backgroundColor: "rgba(20, 24, 33, 0.65)",
        border: "1px solid rgba(255, 255, 255, 0.12)",
        borderRadius: 16,
        padding: 16,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "#ffffff"
    },
    diaTitulo: {
        color: "#ffffff",
        fontWeight: 800,
        fontStyle: "italic",
        textTransform: "uppercase",
        letterSpacing: 1,
        fontSize: 22,
        textAlign: "center",
        margin: "10px 0",
        textShadow: "2px 2px 6px rgba(0, 0, 0, 0.9)"
    },
    diaFecha: {
        color: "#b3b3b3",
        fontSize: 14,
        fontWeight: 500,
        textAlign: "center",
        marginBottom: 12
    },
    boton: {
        width: "100%",
        padding: "14px 24px",
        borderRadius: 12,
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: 14,
        color: "#ffffff",
        letterSpacing: 0.5,
        background: "linear-gradient(180deg, rgba(130, 40, 40, 0.4) 0%, rgba(90, 20, 20, 0.4) 100%)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        cursor: "pointer",
        transition: "transform 0.2s ease",
        outline: "none",
        marginTop: 12,
        "&:active": {
            transform: "scale(0.98)"
        }
    },
    botonesDiv: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "0 16px",
        boxSizing: "border-box"
    },
    sinInfo: {
        width: "100%",
        color: "#a0aec0",
        textAlign: "center"
    },
    carouselWrapper: {
        width: "100%",
        "& .Carousel-indicators": {
            bottom: "auto",
            top: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            margin: 0,
            display: "flex",
            justifyContent: "center",
            gap: 8
        },
        "& .Carousel-indicators-active": {
            backgroundColor: "#2196f3",
            boxShadow: "0 0 8px rgba(33, 150, 243, 0.6)"
        },
        "& .Carousel-indicators button": {
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            border: "none",
            borderRadius: "50%",
            width: 10,
            height: 10,
            padding: 0,
            margin: 0,
            cursor: "pointer"
        }
    }
})

const Enuentros = () => {
    const classes = Styles()
    const { state } = useLocation();
    const navigate = useNavigate()
    const [Encuentros, setEncuentros] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [cantDias, setCantDias] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDatosEnuentros = async () => {
            try {
                setLoading(true)
                let res = await fetch(`${process.env.REACT_APP_BACKEND_LIGA}/Ranking/showEncuentrosRanking/${state.comp_id}&${state.liga_id} `,
                    {
                        method: "GET",
                        headers: { 'Content-type': 'application/json' },
                    })
                let response = await res.json()

                if (response.code === 200) {
                    console.log("ENR", response)
                    setCategorias(response.categorias)
                    setEncuentros(response.dias)
                    setCantDias(response.cantidadDias)
                    setLoading(false)

                } else {
                    console.log("else es 400")
                    setLoading(false)

                }
            } catch (error) {
                console.log(error)
            }
        }
        fetchDatosEnuentros();
    }, [])

    const ClickDisciplina = (datos) => {
        let enc = Encuentros.filter((x) => datos.categoria_id == x.categoria_id)
        navigate('/encuentros/llaves', { state: { llave: enc, comp_id: state.comp_id } })
    }

    function Item(props) {
        return (
            <div className={classes.diaCard}>
                <Typography className={classes.diaTitulo}>Día {props.item[0].dia}</Typography>
                <Typography className={classes.diaFecha}> {props.item[0].categoria_id >= 1 ? moment(props.item[0].fecha).format("DD-MM-YYYY") : ""}</Typography>
                {props.item[0].categoria_id >= 1 ?
                    <div className={classes.botonesDiv}>
                        {props.item.map((x) => {
                            return (
                                <Button onClick={() => ClickDisciplina(x)}
                                    className={classes.boton}>{x.nombre}
                                </Button>
                            )
                        })
                        }
                    </div>
                    : <div className={classes.sinInfo}>
                        <Typography variant="h6" style={{ textAlign: "center" }}>SIN INFORMACION </Typography>
                        <Typography variant="body1" style={{ textAlign: "center" }}>Podra ver los encuentros una vez iniciada la fecha.  </Typography>
                    </div>
                }
            </div>
        )
    }

    let r = []

    for (let index = 1; index <= cantDias; index++) {
        let ds = categorias?.filter((x) => x.dia == index)
        let item = ds
        if (item.length > 0) {
            r.push(<Item key={index} item={item} />)
        } else {
            let info = [{
                dia: index,
                categoria_id: 0,
                competidor_id: 11,
                dia: index,
                fecha: "0",
                liga_id: 2,
                nombre: "Salto " + index,
                tipo_compe: 3
            }]
            r.push(<Item key={index} item={info} />)
        }


    }

    const Icono = (id) => {
        if (id == 1) {
            return (<h2 style={{ color: "whitesmoke" }}>{">"} </h2>)
        }
        if (id == 2) {
            return (<h2 style={{ color: "whitesmoke" }}>{"<"} </h2>)
        }

    }


    return (
        <div className={classes.root}>
            <div className={classes.bg} />
            <div className={classes.content}>
                <div className={classes.header}>
                    <img onClick={() => navigate(-1)} src={logoSC} alt='' className={classes.logologo} />
                    <Typography className={classes.titulo}>Encuentros</Typography>
                </div>
                <Button className={classes.backBtn} onClick={() => navigate(-1)}>
                    Volver
                </Button>
                {loading === false ? <>
                    <div className={classes.carouselWrapper} style={{ width: "100%", paddingBottom: 28 }}>
                        <Carousel NextIcon={Icono(1)} PrevIcon={Icono(2)} animation="slide" autoPlay={false} indicators={true} cycleNavigation={false}  >
                            {r}
                        </Carousel>
                    </div>
                </>
                    : <>
                        <CircularProgress style={{ color: "#39ff14" }} />
                    </>
                }
            </div>
        </div>
    );
}

export default Enuentros;
